import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddServiceTaskComponent } from './add-service-task.component';
import { SharedModule } from 'app/shared/shared.module';



@NgModule({
  declarations: [
    AddServiceTaskComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    AddServiceTaskComponent
  ]
})
export class AddServiceTaskModule { }
